export default __webpack_public_path__ + "static/media/btn-pause.1dc171b9.svg";